import { Sport } from '../types';

export const DEFAULT_SPORT_ID: number = Sport.MLB; // Major League Baseball;
